var map = {
	"./dice1.mp3": "./src/sound/dice1.mp3",
	"./dice2.mp3": "./src/sound/dice2.mp3",
	"./dice3.mp3": "./src/sound/dice3.mp3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/sound sync recursive ^\\.\\/dice.*\\.mp3$";